import React, { memo } from "react";
import { labelField } from "../CommonForm/CommonFormInterface";

const HtmlString = memo(
  ({
    field,
    htmlString,
    handleClick,
    handleOnMouseEnter,
    handleOnMouseLeave,
  }: {
    field: labelField;
    htmlString: string;
    handleClick: Function;
    handleOnMouseEnter: Function;
    handleOnMouseLeave: Function;
  }) => {

    return (
      <div
        className={field.className}
        style={field?.style}
        id={field?.id}
        dangerouslySetInnerHTML={{ __html: htmlString }}
        onClick={(e) => handleClick(e)}
        onMouseEnter={(e) => handleOnMouseEnter(e)}
        {...(field?.properties?.onMouseLeave
          ? { onMouseLeave: (e) => handleOnMouseLeave(e) }
          : {})}
        {...(field?.properties?.onMouseEnter
          ? { onMouseLeave: (e) => handleOnMouseLeave(e) }
          : {})}
        {...(field?.actions
          ? { onMouseLeave: (e) => handleOnMouseLeave(e) }
          : {})}
      />
    );
  }
);

export default HtmlString;
